import { createTheme, darken, lighten } from '@mui/material/styles';

const black = '#000000';
const white = '#ffffff';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: black,
            contrastText: white,
            light: lighten(black, 0.2),
            dark: darken(black, 0.2),
        },
        background: { default: white, paper: white },
        text: { primary: black, secondary: '#444444', disabled: '#aaaaaa' },
        error: { main: '#D32F2F' },
        warning: { main: '#ED6C02' },
        info: { main: '#0288D1' },
        success: { main: '#2E7D32' },
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                    // ❌ do not set a global text color here
                },
            },
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        backgroundColor: black,
                        color: white, // ✅ ensure white text on contained buttons
                        '&:hover': { backgroundColor: lighten(black, 0.2) },
                    },
                },
                {
                    props: { variant: 'outlined' },
                    style: {
                        color: black,
                        borderColor: black,
                        '&:hover': { backgroundColor: lighten(black, 0.9) },
                    },
                },
            ],
        },
    },
});

export default theme;